<template>
  <button
    v-bind:class="[color == 'orange' ? 'orange-button' : 'purple-button']">
    {{buttonText}}
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    color: String,
    buttonText: String,
    path: String
  }
}
</script>

<style>
button {
  border: none;
  border-radius: 286px;
  font-size: 30px;
  font-family: 'Open Sans', sans-serif;
  color: rgb(255, 255, 255);
  font-weight: 900;
  text-transform: uppercase;
  line-height: 1.2;
  text-align: center;
  text-shadow: 1px 1.732px 1px rgba(0, 0, 0, 0.34);
  width: 286px;
  height: 70px;
  outline: none;
}
.orange-button {
  background: linear-gradient( 93deg, rgb(253,151,7) 0%, rgb(254,130,4) 47%, rgb(255,109,0) 100%);
  box-shadow: inset 3px 6px 4px 0 rgb(255, 181, 77);
}
.purple-button {
  background: linear-gradient( 90deg, rgb(51,51,153) 0%, rgb(51,0,102) 100%);
  box-shadow: inset -3px 6px 4px 0 rgb(102, 51, 153);
}
</style>